import React, { Component } from 'react'
import {
  FormControl,
  Form,
  FormGroup,
  ControlLabel
} from 'react-bootstrap'

import { BootstrapTable } from 'react-bootstrap-table'
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'
import Authenticated from '../../lib/Authenticated'
import { blockingFetchService } from '../../lib/blockingFetch'
import apiServerApi from '../../redux/sagas/apiServerApi'
import AlertModal from '../fragments/AlertModal'

class CustomerTable extends Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()

  constructor(props) {
    super(props)

    this.state = {
      businessId: null,
      customerId: null,
      customerFullName: null,
      businessName: null,
      showAffiliateModal: false,
      itemSelected: false,
      selectedRow: { id: null },
      selectRowProp: {
        mode: "radio",
        clickToSelect: true,
        hideSelectColumn: true,
        bgColor: "#9bbfdd",
        onSelect: this.onRowSelect
      },
    }

    this.customerTableRef = null 
    this.setCustomerTableRef = elt => {
      this.customerTableRef = elt
    }
  }

  onRowSelect = (row, isSelected, e) => {

    if (isSelected === true) {
      this.setState({ selectedRow: row })
    }
    this.setState({ itemSelected: isSelected })
  }

  businessIdChanged = (businessId, businesses, selectedRow) => {

    const customerId = selectedRow ? selectedRow.id : '',
    customerFullName = selectedRow ? selectedRow.fullName : '',

    business = businesses.find(item => item.id === businessId),
    businessName = business ? `${ business.name } - ${ business.businessId }` : ''

    this.setState({
      businessId,
      customerId,
      customerFullName,
      businessName,
      showAffiliateModal: true
    })
  }

  businessIdConfirmed = (customerId, businessId) => {

    this.closeConfirmAffiliation()
    if(!customerId) return

    const { setCustomer } = this.props
    blockingFetchService(
      accessToken => apiServerApi.affiliateCustomer(accessToken, customerId, businessId), 
      resp => setCustomer(customerId, resp),
      _ => {},
      _ => {
        if (this.customerTableRef) {
          this.customerTableRef.cleanSelected()
        }
        this.setState({ itemSelected: false, selectedRow: { id: null }})
      }
    )
  }

  getCurrentBusinessId = selectedRow =>
    (selectedRow && selectedRow.business) ? selectedRow.business.id : ''

  closeConfirmAffiliation = () => this.setState({ showAffiliateModal: false })

  renderToolbar = (businesses, itemSelected, selectedRow) => {

    if(!this.isAdmin || !itemSelected) return null

    return (
      <Form inline className='margin-bottom-40'>
        <FormGroup controlId="customerForm">
          <ControlLabel>Affiliated</ControlLabel>{' '}
          <FormControl componentClass="select" placeholder="select"
            value={ this.getCurrentBusinessId(selectedRow) }
            onChange={e => this.businessIdChanged(e.target.value, businesses, selectedRow)}>
            <option value=""></option>
            { businesses.map(item => <option key={ item.id } value={ item.id }>
              { item.name } - { item.businessId }</option>) }
          </FormControl>
        </FormGroup>
      </Form>
    )
  }

  renderContent() {

    const { selectRowProp, showAffiliateModal, customerFullName, businessName,
      businessId, customerId, itemSelected, selectedRow } = this.state,

    { items, children, businesses, dataTotalSize, sizePerPage, onPageChange,
      page, onSizePerPageList, onFilterChange, onSortChange } = this.props,

    msg = businessId
      ? <span>Do you want to affiliate <strong>{ customerFullName }
      </strong> with <em>{ businessName}</em>?</span>
      : <span>Do you want to disaffiliate <strong>{ customerFullName }</strong>?</span>,

    bsStyle = businessId ? 'primary' : 'danger'

    return (
      <div>

        <BootstrapTable
          data={ items }
          striped
          hover
          condensed
          pagination
          selectRow={ selectRowProp }
          remote
          fetchInfo={{ dataTotalSize }}
          options={{
            sizePerPage,
            onPageChange,
            page,
            onSizePerPageList,
            onFilterChange,
            onSortChange,
            sizePerPageList: [10, 25, 50, 100]
          }}
          exportCSV={ this.isAdmin }
          csvFileName='Customers.csv'
          ref={ this.setCustomerTableRef }>
          { children }
        </BootstrapTable>

        { this.renderToolbar(businesses, itemSelected, selectedRow) }

        <AlertModal
          show={ showAffiliateModal }
          close={ this.closeConfirmAffiliation }
          confirm={() => this.businessIdConfirmed(customerId, businessId)}
          title='Customer Affiliation'
          body={ <h4>{ msg }</h4> }
          bsStyle={ bsStyle }
          proceedText='Proceed'
        />
      </div>
    )
  }

  render() {
    return (
      this.props.loading ? <p>Loading...</p> : this.renderContent()
    )
  }
}

export default CustomerTable



// WEBPACK FOOTER //
// ./src/components/Customers/CustomerTable.js